import { useState } from "react";
import {
    FiRepeat,

    FiSave,
    FiX,
    FiXCircle,
} from "react-icons/fi";

const initialState = {
    fechaTransferencia: "",
    idCuentaOrigen: "",
    idCuentaDestino: "",
    monto: "",
    idMoneda: "",
    tipoCambio: "",
    observacion: "",
};

export default function TransferenciaForm({
                                              cuentas = [],
                                              monedas = [],
                                              onClose,
                                              onSave,
                                          }) {
    const [form, setForm] = useState(initialState);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        await onSave({
            ...form,
            idCuentaOrigen: Number(form.idCuentaOrigen),
            idCuentaDestino: Number(form.idCuentaDestino),
            monto: Number(form.monto || 0),
            idMoneda: Number(form.idMoneda || 0),
            tipoCambio: form.tipoCambio ? Number(form.tipoCambio) : null,
        });
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-card">
                <div className="modal-header">
                    <h3 style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <FiRepeat size={20} />
                        Nueva transferencia
                    </h3>

                    <button className="btn-secondary" type="button" onClick={onClose}>
                        <FiX size={16} />
                    </button>
                </div>

                <form className="grid-form" onSubmit={handleSubmit}>
                    <div>
                        <label>Fecha de transferencia</label>
                        <input
                            type="date"
                            name="fechaTransferencia"
                            value={form.fechaTransferencia}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Cuenta origen</label>
                        <select
                            name="idCuentaOrigen"
                            value={form.idCuentaOrigen}
                            onChange={handleChange}
                        >
                            <option value="">Seleccione cuenta origen</option>
                            {cuentas.map((c) => {
                                const id = c.idCuenta ?? c.id_cuenta;
                                return (
                                    <option key={id} value={id}>
                                        {c.nombre}
                                    </option>
                                );
                            })}
                        </select>
                    </div>

                    <div>
                        <label>Cuenta destino</label>
                        <select
                            name="idCuentaDestino"
                            value={form.idCuentaDestino}
                            onChange={handleChange}
                        >
                            <option value="">Seleccione cuenta destino</option>
                            {cuentas.map((c) => {
                                const id = c.idCuenta ?? c.id_cuenta;
                                return (
                                    <option key={id} value={id}>
                                        {c.nombre}
                                    </option>
                                );
                            })}
                        </select>
                    </div>

                    <div>
                        <label>Monto</label>
                        <input
                            type="number"
                            step="0.01"
                            name="monto"
                            placeholder="0.00"
                            value={form.monto}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Moneda</label>
                        <select
                            name="idMoneda"
                            value={form.idMoneda}
                            onChange={handleChange}
                        >
                            <option value="">Seleccione moneda</option>
                            {monedas.map((m) => {
                                const id = m.idMoneda ?? m.id_moneda;
                                return (
                                    <option key={id} value={id}>
                                        {m.codigo} - {m.nombre}
                                    </option>
                                );
                            })}
                        </select>
                    </div>

                    <div>
                        <label>Tipo de cambio</label>
                        <input
                            type="number"
                            step="0.0001"
                            name="tipoCambio"
                            placeholder="Ej. 3.7500"
                            value={form.tipoCambio}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="full-width">
                        <label>Observación</label>
                        <textarea
                            className="full-width"
                            name="observacion"
                            placeholder="Detalle adicional de la transferencia"
                            value={form.observacion}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-actions full-width">
                        <button className="btn-secondary" type="button" onClick={onClose}>
                            <FiXCircle size={16} />
                            Cancelar
                        </button>

                        <button className="btn-primary" type="submit">
                            <FiSave size={16} />
                            Transferir
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}